'use client';

import { getIndustryIcon } from '@/lib/industry-icons';

interface IndustryIconProps {
  name: string;
  size?: number;
  className?: string;
}

export function IndustryIcon({ name, size = 32, className }: IndustryIconProps) {
  const Icon = getIndustryIcon(name);
  return <Icon size={size} className={className} />;
}
